export function setLocale(locale = "fr") {
  return {
    type: "SWITCH_LOCALE",
    locale: locale
  };
}

export function setKiosk(kiosk) {
  return {
    type: "SET_KIOSK",
    kiosk
  };
}